import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { useJwt } from "./useJwt"; // Adjust path as needed

interface TokenPayload {
    establishment_id?: string;
}

const useEstablishmentId = (): string | undefined => {
    const { isAuthenticated, isLoading } = useAuth();
    const [establishmentId, setEstablishmentId] = useState<string | undefined>();
    const decodedJwt = useJwt() as TokenPayload;

    useEffect(() => {
        if (isLoading || !isAuthenticated) {
            setEstablishmentId(undefined);
            return;
        }

        setEstablishmentId(decodedJwt?.establishment_id);
    }, [isAuthenticated, isLoading, decodedJwt]);

    return establishmentId;
};

export default useEstablishmentId;
